import React from 'react';
import ConfirmMailContent from 'akasia-components/authentication/ConfirmMailContent';

const ConfirmarEmail = () => (
  <div className="text-center">
    <ConfirmMailContent email="xyz@abc.com" />
  </div>
);

export default ConfirmarEmail;
